'use client';

import React from 'react';
import { RichPopover } from '@sharpr/ui/rich-popover';
import type { GameWeather } from '@/services/weather/types';
import { pickSeverity } from '@/services/weather/classify';
import { WeatherDetailCard } from './WeatherDetailCard';
import { WeatherTrigger, WeatherDrawerHeader, formatWeatherLabel } from './WeatherTrigger';

interface WeatherPillProps {
  weather: GameWeather;
  size?: 'sm' | 'xs' | '2xs';
  className?: string;
  /** Classes on the popover's tap-target span (defaults to `inline-flex`).
   *  Use this — not `className` (which styles the visible pill) — to expand the
   *  touch target without enlarging the pill itself. */
  wrapperClassName?: string;
}

export function WeatherPill({ weather, size = 'xs', className, wrapperClassName }: WeatherPillProps) {
  if (weather.indoorVenue) return null;
  const sev = pickSeverity(weather);
  return (
    <RichPopover
      trigger={<WeatherTrigger weather={weather} size={size} className={className} />}
      wrapperClassName={wrapperClassName}
      header={<WeatherDrawerHeader weather={weather} />}
      ariaLabel={`Weather: ${formatWeatherLabel(sev)}`}
      width={320}
      showArrow={false}
      openOn="click"
      drawerDescription="Weather forecast and wind details for first pitch."
    >
      <WeatherDetailCard weather={weather} className="rounded-none border-0 shadow-none w-full" />
    </RichPopover>
  );
}
